/* eslint-disable no-console */
import Vue from 'vue'
import VueI18n from 'vue-i18n'

import PageItemsApi from '@/services/api/page.api'

Vue.use(VueI18n)
const i18n = new VueI18n({
    locale: 'fr',
    fallbackLocale: 'en'
})

const switchLang = function(lang){
    i18n.locale = lang;
    document.getElementsByTagName("html")[0].lang = lang;
}

const i18nKey = function(section, obj, field){
    var objType
    try {
        if(typeof(obj) == 'string') {
            objType = obj
        } else {
            objType = obj.type ? obj.type : obj.id
        }
        return section + "." + objType + "." + field
    }
    catch(err) {
        console.log("i18n.js i18nKey: ", err)
    }
}

Vue.mixin({
    methods: {
        iKey: i18nKey,
        switchLang
    }
})



var translations_en = {};
var translations_fr = {};

const appendTrans = function(section, obj, field, value_en, value_fr){
    var token = i18nKey(section, obj, field)
    translations_en[token] = value_en
    translations_fr[token] = value_fr
}

const appendVidTrans = function(transLabel, obj, objLabel=""){
    let vid_url_en = obj.video_url_en ? obj.video_url_en.embed : ""
    let vid_url_fr = obj.video_url_fr ? obj.video_url_fr.embed : ""
    let vid_url_desc_en = obj.video_desc_url_en ? obj.video_desc_url_en.embed : ""
    let vid_url_desc_fr = obj.video_desc_url_fr ? obj.video_desc_url_fr.embed : ""
    obj = objLabel ? objLabel : obj
    appendTrans(transLabel, obj, 'video_embed', vid_url_en, vid_url_fr)
    appendTrans(transLabel, obj, 'video_desc_embed', vid_url_desc_en, vid_url_desc_fr)
}

const gatherTranslations = async function(){


    // Upstander Page Items /////////////////////////////////////////////////////////
    const response = await PageItemsApi.getPageItems()

    // Menu Items
    try {
        response.data.related_menu_items.forEach(obj => {
            var s = 'related_menu_items'
            appendTrans(s, obj, 'section_id', obj.section_id_en, obj.section_id_fr)
            appendTrans(s, obj, 'section_label', obj.section_label_en, obj.section_label_fr)
        })
    }
    catch(err){
        console.log("i18n.js response.data.related_menu_items:", err)
    }

    // Intro Splash
    try {
        response.data.intro_question.forEach(obj => {
            appendTrans('intro_question', obj, 'text', obj.value.text_en, obj.value.text_fr)
        })
        response.data.related_intro_steps.forEach(obj => {
            appendTrans('related_intro_steps', obj, 'copy', obj.copy_en, obj.copy_fr)
        })
    }
    catch(err){
        console.log("i18n.js response.data.related_intro_steps:", err)
    }

    // Intro Section
    try {
        response.data.intro_section.forEach(obj => {
            appendTrans('intro_section', obj, 'text', obj.value.text_en, obj.value.text_fr)
        })
    }
    catch(err){
        console.log("i18n.js response.data.intro_section:", err)
    }

    // Case Study Intro
    try {
        response.data.case_study_section.forEach(obj => {
            var s = 'case_study_section'
            if(obj.type == 'case_study_intro') {
                appendTrans(s, obj, 'label', obj.value.label_en, obj.value.label_fr)
                appendTrans(s, obj, 'headline', obj.value.headline_en, obj.value.headline_fr)
                appendTrans(s, obj, 'description', obj.value.description_en, obj.value.description_fr)
                appendTrans(s, obj, 'cta', obj.value.cta_en, obj.value.cta_fr)
                appendTrans(s, obj, 'cta_next', obj.value.cta_next_en, obj.value.cta_next_fr)
            }

            if(obj.type == 'case_study_traits') {
                appendTrans(s, obj, 'cta', obj.value.cta_en, obj.value.cta_fr)
                appendTrans(s, obj, 'cta_touch', obj.value.cta_touch_en, obj.value.cta_touch_fr)
                appendTrans(s, obj, 'select_color', obj.value.select_color_en, obj.value.select_color_fr)
                appendTrans(s, obj, 'remove_highlight', obj.value.remove_highlight_en, obj.value.remove_highlight_fr)
                obj.value.labels.forEach((l, index) => {
                    appendTrans(s, obj, 'label_' + index, l.label_en, l.label_fr)
                })
            }
            //{{ $t(iKey('case_study_section', 'case_study_traits', 'labels_' + index ))}}
        })
    }
    catch(err){
        console.log("i18n.js response.data.case_study_section:", err)
    }

    // Case Studies
    try {
        response.data.related_case_studies.forEach(obj => {
            var s = 'related_case_studies'
            appendTrans(s, obj, 'label', obj.label_en, obj.label_fr)
            appendTrans(s, obj, 'action', obj.action_en, obj.action_fr)
            appendTrans(s, obj, 'pull_quote', obj.pull_quote_en, obj.pull_quote_fr)
            appendTrans(s, obj, 'pull_quote_attr', obj.pull_quote_attr_en, obj.pull_quote_attr_fr)
            if(obj.main_image){
                appendTrans(s, obj, 'main_image_caption', obj.main_image.caption_en, obj.main_image.caption_fr)
                appendTrans(s, obj, 'main_image_desc', obj.main_image.desc_en, obj.main_image.desc_fr)
            }
            if(obj.secondary_image){
                appendTrans(s, obj, 'secondary_image_caption', obj.secondary_image.caption_en, obj.secondary_image.caption_fr)
                appendTrans(s, obj, 'secondary_image_desc', obj.secondary_image.desc_en, obj.secondary_image.desc_fr)
                appendTrans(s, obj, 'secondary_video_desc', obj.secondary_video_desc_en, obj.secondary_video_desc_fr)
            }
            appendVidTrans(s, obj);

            appendTrans(s, obj, 'paragraph_1', obj.paragraph_1_en, obj.paragraph_1_fr)
            appendTrans(s, obj, 'paragraph_2', obj.paragraph_2_en, obj.paragraph_2_fr)
            appendTrans(s, obj, 'transition_next', obj.transition_next_en, obj.transition_next_fr)
        })
    }
    catch(err){
        console.log("i18n.js response.data.related_case_studies:", err)
    }

    // Personal Upstander
    try {
        response.data.personal_upstander_section.forEach(obj => {
            var s = 'personal_upstander_section'
            appendTrans(s, obj, 'label', obj.value.label_en, obj.value.label_fr)
            appendTrans(s, obj, 'roles_sentence', obj.value.roles_sentence_en, obj.value.roles_sentence_fr)
            appendTrans(s, obj, 'strengths_sentence', obj.value.strengths_sentence_en, obj.value.strengths_sentence_fr)
            appendTrans(s, obj, 'changes_sentence', obj.value.changes_sentence_en, obj.value.changes_sentence_fr)
            appendTrans(s, obj, 'reset_label', obj.value.reset_label_en, obj.value.reset_label_fr)

            obj.value.roles.forEach((l, index) => {
                appendTrans(s, obj, 'role_' + index, l.role_en, l.role_fr)
            })
            obj.value.strengths.forEach((l, index) => {
                appendTrans(s, obj, 'strength_' + index, l.strength_en, l.strength_fr)
            })
            obj.value.changes.forEach((l, index) => {
                appendTrans(s, obj, 'change_' + index, l.change_en, l.change_fr)
            })
        })
    }
    catch(err){
        console.log("i18n.js response.data.personal_upstander_section:", err)
    }

    // Transition Block
    try {
        response.data.transition_section.forEach(obj => {
            var s = 'transition_section'
            appendTrans(s, obj, 'text', obj.value.text_en, obj.value.text_fr)
        })
    }
    catch(err){
        console.log("i18n.js response.data.transition_section:", err)
    }

    // Profile Section Intro
    try {
        response.data.profiles_section.forEach(obj => {
            var s = 'profiles_section'
            appendTrans(s, obj, 'text', obj.value.text_en, obj.value.text_fr)
            if(obj.type == 'profile_labels'){
                appendTrans(s, obj, 'profile_label', obj.value.profile_label_en, obj.value.profile_label_fr)
                appendTrans(s, obj, 'stands_for', obj.value.stands_for_en, obj.value.stands_for_fr)
            }
        })
    }
    catch(err){
        console.log("i18n.js response.data.related_upstander_profiles:", err)
    }

    // Profiles
    try {
        response.data.related_upstander_profiles.forEach(obj => {
            var s = 'related_upstander_profiles'
            appendTrans(s, obj, 'issue', obj.issue_en, obj.issue_fr)
            appendTrans(s, obj, 'paragraph_1', obj.paragraph_1_en, obj.paragraph_1_fr)
            appendTrans(s, obj, 'paragraph_2', obj.paragraph_2_en, obj.paragraph_2_fr)
            appendTrans(s, obj, 'pull_quote', obj.pull_quote_en, obj.pull_quote_fr)
            appendTrans(s, obj, 'action', obj.action_en, obj.action_fr)
            if(obj.profile_image){
                appendTrans(s, obj, 'profile_image_desc', obj.profile_image.desc_en, obj.profile_image.desc_fr)
            }
            if(obj.secondary_image){
                appendTrans(s, obj, 'secondary_image_caption', obj.secondary_image.caption_en, obj.secondary_image.caption_fr)
                appendTrans(s, obj, 'secondary_image_desc', obj.secondary_image.desc_en, obj.secondary_image.desc_fr)
            }
            appendVidTrans(s, obj);
            
        })
    }
    catch(err){
        console.log("i18n.js response.data.related_upstander_profiles:", err)
    }

    // UDHR Section Intro
    try {
        response.data.udhr_section.forEach(obj => {
            var s = 'udhr_section'
            if(obj.type == 'udhr_intro'){
                appendTrans(s, obj, 'headline', obj.value.headline_en, obj.value.headline_fr)
                appendTrans(s, obj, 'description', obj.value.description_en, obj.value.description_fr)
                appendTrans(s, obj, 'image_caption', obj.value.image.caption_en, obj.value.image.caption_fr)
                appendTrans(s, obj, 'image_desc', obj.value.image.desc_en, obj.value.image.desc_fr)
                appendTrans(s, obj, 'image_pull_quote', obj.value.image_pull_quote_en, obj.value.image_pull_quote_fr)
                appendTrans(s, obj, 'cta', obj.value.cta_en, obj.value.cta_fr)
            } else if(obj.type == 'udhr_instructions'){
                appendTrans(s, obj, 'headline', obj.value.headline_en, obj.value.headline_fr)
                appendTrans(s, obj, 'description', obj.value.description_en, obj.value.description_fr)
                appendTrans(s, obj, 'image_desc', obj.value.image.desc_en, obj.value.image.desc_fr)
            }
        })
    }
    catch(err){
        console.log("i18n.js response.data.related_upstander_profiles:", err)
    }

    // UDHR Articles
    try {
        response.data.related_udhr_articles.forEach(obj => {
            var s = 'related_udhr_articles'
            appendTrans(s, obj, 'label', obj.label_en, obj.label_fr)
            appendTrans(s, obj, 'title', obj.title_en, obj.title_fr)
            appendTrans(s, obj, 'description', obj.description_en, obj.description_fr)
            if(obj.illustration){
                appendTrans(s, obj, 'illustration_caption', obj.illustration.caption_en, obj.illustration.caption_fr)
                appendTrans(s, obj, 'illustration_desc', obj.illustration.desc_en, obj.illustration.desc_fr)
            }
        })
    }
    catch(err){
        console.log("i18n.js response.data.related_udhr_articles:", err)
    }

    // Issue Selection
    try {
        response.data.issue_selection_section.forEach(obj => {
            var s = 'issue_selection_section'
            appendTrans(s, obj, 'headline', obj.value.headline_en, obj.value.headline_fr)
            appendTrans(s, obj, 'cta', obj.value.cta_en, obj.value.cta_fr)
            appendTrans(s, obj, 'help_text', obj.value.help_text_en, obj.value.help_text_fr)
            appendTrans(s, obj, 'button', obj.value.button_en, obj.value.button_fr)
            appendTrans(s, obj, 'cta_next', obj.value.cta_next_en, obj.value.cta_next_fr)
        })
    }
    catch(err){
        console.log("i18n.js response.data.issue_selection_section:", err)
    }

    // Know Section
    try {
        response.data.know_section.forEach(obj => {
            var s = 'know_section'
            appendTrans(s, obj, 'label', obj.value.label_en, obj.value.label_fr)
            appendTrans(s, obj, 'headline', obj.value.headline_en, obj.value.headline_fr)
            obj.value.questions.forEach((q, index) => {
                appendTrans(s, obj, 'question_' + index, q.question_en, q.question_fr)
            })
            
        })
    }
    catch(err){
        console.log("i18n.js response.data.know_section:", err)
    }

    // Personal Strengths Section
    try {
        response.data.personal_strengths_section.forEach(obj => {
            var s = 'personal_strengths_section'
            appendTrans(s, obj, 'transition', obj.value.transition_en, obj.value.transition_fr)
            appendTrans(s, obj, 'transition_out', obj.value.transition_out_en, obj.value.transition_out_fr)
            appendTrans(s, obj, 'headline', obj.value.headline_en, obj.value.headline_fr)
            appendTrans(s, obj, 'description', obj.value.description_en, obj.value.description_fr)
            appendTrans(s, obj, 'name_placeholder', obj.value.name_placeholder_en, obj.value.name_placeholder_fr)  
            appendTrans(s, obj, 'strength_placeholder', obj.value.strength_placeholder_en, obj.value.strength_placeholder_fr)    
            appendTrans(s, obj, 'cause_placeholder', obj.value.cause_placeholder_en, obj.value.cause_placeholder_fr)  
            appendTrans(s, obj, 'statement', obj.value.statement_en, obj.value.statement_fr)    
            appendTrans(s, obj, 'submit', obj.value.submit_en, obj.value.submit_fr)            
        })
    }
    catch(err){
        console.log("i18n.js response.data.personal_strengths_section:", err)
    }

    // Tell Section
    try {
        response.data.tell_section.forEach(obj => {
            var s = 'tell_section'
            appendTrans(s, obj, 'label', obj.value.label_en, obj.value.label_fr)
            appendTrans(s, obj, 'cta', obj.value.cta_en, obj.value.cta_fr) 
            appendTrans(s, obj, 'congrats', obj.value.congrats_en, obj.value.congrats_fr)    
        })
    }
    catch(err){
        console.log("i18n.js response.data.tell_section:", err)
    }

     // Act Section
     try {
        response.data.act_section.forEach(obj => {
            var s = 'act_section'
            appendTrans(s, obj, 'label', obj.value.label_en, obj.value.label_fr)
            obj.value.statements.forEach((q, index) => {
                appendTrans(s, obj, 'statement_' + index, q.statement_en, q.statement_fr)
            })
        })
    }
    catch(err){
        console.log("i18n.js response.data.act_section:", err)
    }

     // Canada's Upstanders Section
     try {
        response.data.canadas_upstanders_section.forEach(obj => {
            var s = 'canadas_upstanders_section'
            appendTrans(s, obj, 'headline', obj.value.headline_en, obj.value.headline_fr)
            appendTrans(s, obj, 'description', obj.value.description_en, obj.value.description_fr)    
        })
        
    }
    catch(err){
        console.log("i18n.js response.data.canadas_upstanders_section:", err)
    }

    // Upstander Video
    try {
        let obj = response.data;
        let s = 'main_video'
        appendVidTrans(s, obj, "video");
    }
    catch(err){
        console.log("i18n.js response.data.main_video:", err)
    }


    // Related Upstander Schools
    try {
        response.data.related_upstander_schools.forEach(obj => {
            var s = 'related_upstander_schools'
            appendTrans(s, obj, 'name', obj.name_en, obj.name_fr)
            appendTrans(s, obj, 'description', obj.description_en, obj.description_fr)

            appendVidTrans(s, obj);
        })
        
    }
    catch(err){
        console.log("i18n.js response.data.related_upstander_schools:", err)
    }
    
     // Footer Section
     try {
        response.data.footer_section.forEach(obj => {
            var s = 'footer_section'
            appendTrans(s, 'notice', 'text', obj.value.notice_en,  obj.value.notice_fr)
            appendTrans(s, 'site_links', 'header', obj.value.site_links_header_en,  obj.value.site_links_header_fr)
            appendTrans(s, 'copyright', 'text', obj.value.copyright_en, obj.value.copyright_fr)
            obj.value.site_links.forEach((l, index) => {
                appendTrans(s, 'site_link', 'label_' + index, l.link_label_en, l.link_label_fr)
                appendTrans(s, 'site_link', 'url_' + index, l.link_url_en, l.link_url_fr)
            })
            obj.value.legal_links.forEach((l, index) => {
                appendTrans(s, 'legal_link', 'label_' + index, l.link_label_en, l.link_label_fr)
                appendTrans(s, 'legal_link', 'url_' + index, l.link_url_en, l.link_url_fr)
            })
        })
    }
    catch(err){
        console.log("i18n.js response.data.footer_section:", err)
    }

    // Ui Label Section
    try {
        response.data.ui_labels.forEach(obj => {
            var s = 'ui_labels'
            appendTrans(s, obj, 'with_desc_audio', obj.value.with_descr_audio_en,  obj.value.with_descr_audio_fr)
            appendTrans(s, obj, 'without_desc_audio', obj.value.without_descr_audio_en,  obj.value.without_descr_audio_fr)
            appendTrans(s, obj, 'social_share_label', obj.value.social_share_label_en,  obj.value.social_share_label_fr)
            appendTrans(s, obj, 'teacher_guide', obj.value.teacher_guide_en,  obj.value.teacher_guide_fr)
            appendTrans(s, obj, 'student_view', obj.value.student_view_en,  obj.value.student_view_fr)
            appendTrans(s, obj, 'back', obj.value.back_en,  obj.value.back_fr)
        })
    }
    catch(err){
        console.log("i18n.js response.data.ui_labels:", err)
    }

    // Social Share
    try {
        let obj = response.data;
        let s = 'share'
        appendTrans(s, 'social', 'share_title', obj.share_title_en,  obj.share_title_fr)
        appendTrans(s, 'social', 'share_description', obj.share_description_en,  obj.share_description_fr)
        appendTrans(s, 'social', 'share_description_twitter', obj.share_description_twitter_en,  obj.share_description_twitter_fr)
    }
    catch(err){
        console.log("i18n.js response.data.social_share:", err)
    }

    // Teacher Guide Items /////////////////////////////////////////////////////////
    const response_tg = await PageItemsApi.getTeacherGuideItems()

    try {
        let s = 'teacher_guide'
        let obj = response_tg.data
        if(obj.banner_image){
            appendTrans(s, 'ui', 'banner_image_desc', obj.banner_image.desc_en, obj.banner_image.desc_fr)
        }
        appendTrans(s, 'ui', 'modal_headline', obj.modal_headline_en, obj.modal_headline_fr)
        appendTrans(s, 'ui', 'modal_description', obj.modal_description_en, obj.modal_description_fr)
        appendTrans(s, 'ui', 'headline', obj.headline_en, obj.headline_fr)
        appendTrans(s, 'ui', 'description', obj.description_en, obj.description_fr)
        appendTrans(s, 'ui', 'download_button', obj.download_button_en, obj.download_button_fr)
        appendTrans(s, 'ui', 'tip_box', obj.tip_box_en, obj.tip_box_fr)
        appendTrans(s, 'ui', 'student_version', obj.student_version_en, obj.student_version_fr)
        appendTrans(s, 'ui', 'lesson_objective_label', obj.lesson_objective_label_en, obj.lesson_objective_label_fr)
        appendTrans(s, 'ui', 'lesson_summary_label', obj.lesson_summary_label_en, obj.lesson_summary_label_en)
        appendTrans(s, 'ui', 'lesson_activities_label', obj.lesson_activities_label_en, obj.lesson_activities_label_en)

        obj.related_lesson_documents.forEach((doc, index) =>{
            var d_id = 'overview_doc_' + index;
            appendTrans(s, d_id, 'label', doc.label_en, doc.label_fr)
            appendTrans(s, d_id, 'url', doc.document_en.meta.download_url, doc.document_fr.meta.download_url)
        })
       
        obj.lessons.forEach((lesson, index) => {
            var l_id = 'lesson_' + index;
            appendTrans(s, l_id, 'label', lesson.value.label_en, lesson.value.label_fr)
            appendTrans(s, l_id, 'objective', lesson.value.objective_en, lesson.value.objective_fr)
            appendTrans(s, l_id, 'summary', lesson.value.summary_en, lesson.value.summary_fr)

            try {
                appendTrans(s, l_id, 'screenshot_url', lesson.value.screenshot_en.url_resized, lesson.value.screenshot_fr.url_resized)
                appendTrans(s, l_id, 'screenshot_desc', lesson.value.screenshot_en.desc_en, lesson.value.screenshot_fr.desc_fr)
            } catch(err) {
                console.log('i18n.js response.data.teacher_guide lessons:', err)
            }
            
            lesson.value.activities.forEach((doc, doc_index) => {
                var doc_id = l_id + '_doc_' + doc_index;
                appendTrans(s, doc_id, 'title', doc.title_en, doc.title_fr)
                try {
                    appendTrans(s, doc_id, 'url', doc.document_en.url, doc.document_fr.url)
                } catch(err) {
                    console.log('i18n.js response.data.teacher_guide activities:', err)
                }
            })
        })
        
        //console.log(obj)
    }
    catch(err){
        console.log("i18n.js response.data.teacher_guide:", err)
    }

    i18n.setLocaleMessage('en', translations_en);
    i18n.setLocaleMessage('fr', translations_fr);

    //console.log(translations_en)
   
}

export {
    i18n,
    i18nKey,
    gatherTranslations
}